/* SuperAdminSpeedDial.js */

import React, { useMemo, useState } from "react";
import {
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon
} from "@mui/material";

import RowingIcon from "@mui/icons-material/Rowing";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import MicrowaveIcon from "@mui/icons-material/Microwave";
import CloseIcon from "@mui/icons-material/Close";
import WbTwilightIcon from "@mui/icons-material/WbTwilight"; // Dawn icon
import HandymanRoundedIcon from "@mui/icons-material/HandymanRounded";

import "./SuperAdminSpeedDial.css";

const PanelType = {
  ADD_ADMIN: 'addAdmin',
  ADMIN_USERS: 'adminUsers',
  HIDDEN_SUBMISSIONS: 'hiddenSubmissions',
  CLONE_PROJECT: 'cloneProject',
  PROJECT_HISTORY: 'projectHistory',
  ASSET_INDEX: 'assetIndex',
  ADMIN_JOBS: 'adminJobs',
};

const SuperAdminSpeedDial = ({
  activePanel,
  onTogglePanel,
  onCloseAllPanels,
  onAddToken,
  onReNumber,
  onTriggerDawn, // NEW PROP
}) => {
  const [speedOpen, setSpeedOpen] = useState(false);

  const actions = useMemo(
    () => [
      {
        key: "triggerDawn",
        name: "Trigger Dawn Summary",
        icon: <WbTwilightIcon />,
        onClick: () => onTriggerDawn?.()
      },
      {
        key: "addToken",
        name: "Add Token (1st Place)",
        icon: <RowingIcon />,
        onClick: () => onAddToken?.()
      },
      {
        key: "renumber",
        name: "Re-Number",
        icon: <ViewModuleIcon />,
        onClick: () => onReNumber?.()
      },
      {
        key: "admins",
        name: activePanel === PanelType.ADMIN_USERS ? "Hide Admins" : "Show Admins",
        icon: <SupervisorAccountIcon />,
        onClick: () => onTogglePanel(PanelType.ADMIN_USERS)
      },
      {
        key: "addAdmin",
        name: activePanel === PanelType.ADD_ADMIN ? "Hide Add Admin" : "Add Admin",
        icon: <PersonAddIcon />,
        onClick: () => onTogglePanel(PanelType.ADD_ADMIN)
      },
      {
        key: "hiddenSubs",
        name: activePanel === PanelType.HIDDEN_SUBMISSIONS ? "Hide Hidden Submissions" : "Hidden Submissions",
        icon: <VisibilityOffIcon />,
        onClick: () => onTogglePanel(PanelType.HIDDEN_SUBMISSIONS)
      },
      {
        key: "cloneProject",
        name: activePanel === PanelType.CLONE_PROJECT ? "Cancel Clone" : "Clone Project",
        icon: <ContentCopyIcon />,
        onClick: () => onTogglePanel(PanelType.CLONE_PROJECT)
      },
      {
        key: "logs",
        name: activePanel === PanelType.PROJECT_HISTORY ? "Hide Logs" : "Logs",
        icon: <ViewModuleIcon />,
        onClick: () => onTogglePanel(PanelType.PROJECT_HISTORY)
      },
      {
        key: "assets",
        name: activePanel === PanelType.ASSET_INDEX ? "Hide Assets" : "Assets",
        icon: <MicrowaveIcon />,
        onClick: () => onTogglePanel(PanelType.ASSET_INDEX)
      },
      {
        key: "adminJobs",
        name: activePanel === PanelType.ADMIN_JOBS ? "Hide Admin Jobs" : "Admin Jobs",
        icon: <HandymanRoundedIcon />,
        onClick: () => onTogglePanel(PanelType.ADMIN_JOBS)
      },
      {
        key: "closeAll",
        name: "Close All",
        icon: <CloseIcon />,
        onClick: () => onCloseAllPanels()
      }
    ],
    [activePanel, onAddToken, onReNumber, onTogglePanel, onCloseAllPanels, onTriggerDawn]
  );

  return (
    <SpeedDial
      ariaLabel="Super admin actions"
      className="sasdSpeedDial"
      icon={
        <SpeedDialIcon
          icon={<SupervisorAccountIcon />}
          openIcon={<CloseIcon />}
        />
      }
      onOpen={() => setSpeedOpen(true)}
      onClose={() => setSpeedOpen(false)}
      open={speedOpen}
      direction="down"
    >
      {actions.map((a) => (
        <SpeedDialAction
          key={a.key}
          icon={a.icon}
          tooltipTitle={a.name}
          TooltipProps={{
            placement: "right",
            enterDelay: 250,
            componentsProps: {
              tooltip: {
                sx: {
                  bgcolor: "black",
                  color: "white",
                  fontSize: "0.75rem",
                  maxWidth: "none",
                  whiteSpace: "nowrap",
                  padding: "6px 10px"
                }
              },
              arrow: {
                sx: { color: "black" }
              }
            }
          }}
          onClick={() => {
            setSpeedOpen(false);
            a.onClick();
          }}
        />
      ))}
    </SpeedDial>
  );
};

export default SuperAdminSpeedDial;
